import Link from "next/link";

interface PaginatorProps {
  page?: number;
  totalCount?: number;
  prevUrl?: string;
  nextUrl?: string;
  loading?: boolean;
  disabled?: boolean;
  onPaginate?: (direction: string) => void;
}

export default function Paginator(props: PaginatorProps): JSX.Element {
  const { page, totalCount, prevUrl, nextUrl } = props;
  const { loading, disabled } = props;
  const { onPaginate } = props;
  const loadingClass = loading ? "loading" : "";

  const renderPrevButton = !!prevUrl;
  const renderNextButton = !!nextUrl;

  return (
    <div
      className={`paginator flex w-full justify-between items-center rounded-lg border border-disabled py-2 px-4 fade-loading ${loadingClass}`}
      data-disabled={disabled}
    >
      <Link href={prevUrl || "#"}>
        <a
          onClick={() => onPaginate && onPaginate("prev")}
          className={`prev-page no-underline ${
            !renderPrevButton ? "invisible" : ""
          }`}
        >
          Anterior
        </a>
      </Link>
      <span className="current-page font-semibold">
        {page} / {totalCount}
      </span>
      <Link href={nextUrl || "#"}>
        <a
          onClick={() => onPaginate && onPaginate("next")}
          className={`next-page no-underline ${
            !renderNextButton ? "invisible" : ""
          }`}
        >
          Próxima
        </a>
      </Link>
    </div>
  );
}
